(ns reagent-form.validators
  (:require [clojure.string :as s]))

(defn required [v]
  (cond
    (keyword? v) true

    :else (not (empty? v))))

(defn required-select [options]
  (->> options
       (filter #(= (and (:selected %)
                        (not (:disabled %))) true))
       first
       :value
       empty?
       not))

(defn simple-email
  [v]
  (re-matches #"^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$" v))

(defn simple-email-or-blank
  [v]
  (or (simple-email v)
      (s/blank? v)))

(defn search-count-or-blank
  [v]
  (or (and (<= 3 (count v))
           (<= (count v) 35))
      (s/blank? v)))

(defn alphanumeric
  ([v] (alphanumeric v 6))
  ([v cnt]
   (and (= (count v) cnt)
        (re-matches #"^[a-zA-Z0-9]+$" v))))
